const auth = {
  "form": {
    "login": "ចូលប្រព័ន្ធ",
    "signUp": "ចុះឈ្មោះ",
    "email": "អ៊ីមែល",
    "password": "ពាក្យសម្ងាត់",
    "passwordConfirm": "បញ្ជាក់ពាក្យសម្ងាត់",
    "forgotPassword": "ភ្លេចពាក្យសម្ងាត់",
    "checkDuplicate": "ពិនិត្យការស្ទួន",
    "next": "បន្ទាប់",
    "previous": "ត្រឡប់",
    "backToLogin": "ត្រឡប់ទៅការចូលប្រព័ន្ធ",
    "showPassword": "បង្ហាញពាក្យសម្ងាត់",
    "hidePassword": "លាក់ពាក្យសម្ងាត់",
    "id": "លេខសម្គាល់",
    "name": "ឈ្មោះ",
    "phone": "លេខទូរស័ព្ទ",
    "company": "ស្ថាប័ន",
    "job": "មុខតំណែង",
    "field": "វិស័យ",
    "userInfo": "ព័ត៌មានអ្នកប្រើប្រាស់",
    "verificationCode": "លេខកូដផ្ទៀងផ្ទាត់",
    "resending": "កំពុងផ្ញើឡើងវិញ...",
    "verifying": "កំពុងផ្ទៀងផ្ទាត់...",
    "fieldOptions": {
      "design": "ការរចនា",
      "construction": "ការសំណង់",
      "maintenance": "ការថែទាំ",
      "safetyInspection": "ការត្រួតពិនិត្យសុវត្ថិភាព",
      "survey": "ការស្ទង់",
      "agriculture": "កសិកម្ម",
      "environment": "បរិស្ថាន"
    }
  },
  "validation": {
    "emailRequired": "សូមបញ្ចូលអ៊ីមែល",
    "emailInvalid": "ទម្រង់អ៊ីមែលមិនត្រឹមត្រូវ",
    "passwordRequired": "សូមបញ្ចូលពាក្យសម្ងាត់",
    "passwordConfirmRequired": "សូមបញ្ចូលការបញ្ជាក់ពាក្យសម្ងាត់",
    "passwordMinLength": "ពាក្យសម្ងាត់ត្រូវតែមានយ៉ាងតិច ៨ អក្សរ",
    "nameRequired": "សូមបញ្ចូលឈ្មោះ",
    "phoneRequired": "សូមបញ្ចូលលេខទូរស័ព្ទ",
    "phoneInvalid": "ទម្រង់លេខទូរស័ព្ទមិនត្រឹមត្រូវ",
    "companyRequired": "សូមបញ្ចូលស្ថាប័ន",
    "jobRequired": "សូមបញ្ចូលមុខតំណែង",
    "fieldRequired": "សូមជ្រើសរើសវិស័យ",
    "fieldPlaceholder": "សូមជ្រើសរើស",
    "codeRequired": "សូមបញ្ចូលលេខកូដផ្ទៀងផ្ទាត់",
    "codeSixDigits": "សូមបញ្ចូលលេខ ៦ ខ្ទង់"
  },
  "message": {
    "loginFailed": "ការចូលប្រព័ន្ធបានបរាជ័យ",
    "confirmFailed": "ការផ្ទៀងផ្ទាត់បានបរាជ័យ",
    "resendingConfirmationCode": "បានផ្ញើលេខកូដផ្ទៀងផ្ទាត់ឡើងវិញ។",
    "confirmationCodeResendingFail": "ការផ្ញើឡើងវិញបានបរាជ័យ",
    "fillEmail": "សូមបញ្ចូលអ៊ីមែលដែលបានចុះឈ្មោះ។",
    "sendCodeNumber": "នឹងផ្ញើលេខកូដផ្ទៀងផ្ទាត់ទៅអ្នក។",
    "sentCodeNumber": "បានផ្ញើលេខកូដផ្ទៀងផ្ទាត់រួចហើយ។",
    "sendCodeNumberFailed": "ការផ្ញើលេខកូដបានបរាជ័យ",
    "changePassWordFailed": "ការផ្លាស់ប្ដូរពាក្យសម្ងាត់បានបរាជ័យ",
    "passwordChangeSuccess": "ពាក្យសម្ងាត់បានផ្លាស់ប្ដូរដោយជោគជ័យ។",
    "passwordChangeFailed": "ការផ្លាស់ប្ដូរពាក្យសម្ងាត់បានបរាជ័យ",
    "notMatchCode": "លេខកូដផ្ទៀងផ្ទាត់ត្រូវតែជាលេខ ៦ ខ្ទង់។",
    "signUpFailed": "ការចុះឈ្មោះបានបរាជ័យ",
    "signupRetry": "មិនអាចបញ្ចប់ការចុះឈ្មោះបានទេ។ សូមសាកល្បងម្ដងទៀតក្រោយ។",
    "finishingSignup": "ការចុះឈ្មោះរបស់អ្នកមិនទាន់បានបញ្ចប់ទេ។ កំពុងបញ្ចប់ការចុះឈ្មោះ។",
    "verificationCodeSendFailed": "ការផ្ញើលេខកូដបានបរាជ័យ",
    "verificationCodeSendFailedMessage": "ការផ្ញើលេខកូដបានបរាជ័យ។ សូមសាកល្បងម្ដងទៀត។",
    "getVerificationCode": "ទទួលលេខកូដផ្ទៀងផ្ទាត់",
    "supersededNotice": "អ្នកត្រូវបានចាកចេញពីប្រព័ន្ធ ដោយសារគណនីដដែលត្រូវបានចូលកម្មវិធីនេះនៅលើឧបករណ៍ផ្សេងទៀត។ ដើម្បីបន្ត សូមចូលប្រព័ន្ធម្ដងទៀត។",
    "supersededPartnerNotice": "អ្នកត្រូវបានចាកចេញពីប្រព័ន្ធ ដោយសារគណនីដដែលត្រូវបានចូលកម្មវិធីនេះនៅលើឧបករណ៍ផ្សេងទៀត។ ដើម្បីបន្ត សូមចូលប្រើម្ដងទៀតពី Hi-board។",
    "claimSuperseded": "គណនីនេះត្រូវបានចូលកម្មវិធីនេះថ្មីជាងនេះនៅលើឧបករណ៍ផ្សេងទៀត។ សូមចូលប្រព័ន្ធម្ដងទៀត។",
    "claimUnavailable": "មិនអាចបញ្ជាក់ការចូលប្រព័ន្ធបានទេ។ សូមសាកល្បងម្ដងទៀតក្រោយ។",
    "autoLoginFailed": "ការចូលប្រព័ន្ធដោយស្វ័យប្រវត្តិបានបរាជ័យ។ សូមសាកល្បងម្ដងទៀត។"
  },
  "deviceConflict": {
    "title": "គណនីនេះកំពុងប្រើប្រាស់នៅលើឧបករណ៍ផ្សេងទៀត",
    "body": "គណនីមួយអាចចូលប្រព័ន្ធបានតែលើឧបករណ៍មួយក្នុងពេលតែមួយប៉ុណ្ណោះ សម្រាប់កម្មវិធីនីមួយៗ។ ប្រសិនបើអ្នកចូលប្រព័ន្ធនៅទីនេះ ឧបករណ៍ផ្សេងទៀតដែលកំពុងប្រើកម្មវិធីនេះនឹងត្រូវចាកចេញពីប្រព័ន្ធ។",
    "cancel": "បោះបង់",
    "confirm": "ចូលប្រព័ន្ធ"
  }
} as const;

export default auth;
